export const fr = {
  bookDemoPage: {
    meta: { title: 'Réserver une démo' },
    eyebrow: 'Réserver une démo',
    heading_main: 'Voyez Purposely gérer ',
    heading_em: 'votre programme de bénévolat',
    lead: "Une présentation de 30 minutes avec notre équipe. Nous vous guiderons à travers les flux de travail qui font gagner du temps, vous montrerons des événements en action, et répondrons à toutes vos questions sur les tarifs et le déploiement.",
    expect: [
      {
        title: '30 minutes, échange rapide',
        sub: "Nous apprenons à connaître vos besoins et adaptons l'appel en conséquence.",
      },
      {
        title: 'Une feuille de route, pas un pitch',
        sub: "Vous repartirez avec des prochaines étapes claires, pas un deck de vente à ignorer.",
      },
      {
        title: 'Des tarifs qui évoluent avec vous',
        sub: 'Tarification transparente. Sans frais cachés.',
      },
    ],
    trust: {
      heading: 'La confiance des équipes de',
      logos: ['Clio', 'Hootsuite', 'Boston Dynamics', 'GreenShield'],
    },
    cal: {
      heading: 'Choisissez un créneau',
      sub: "Tous les horaires sont dans votre fuseau horaire local. Nous vous enverrons une invitation de calendrier immédiatement.",
    },
    fallback: {
      strong: 'Vous préférez l\'email ?',
      text: "Nous vous trouverons un créneau dans un jour ouvrable.",
      email: 'demo@purposely.co',
    },
  },
}
